import toDate from '../to-date';

export const getDate = (date: Date | number): number => {
  const formattedDate = toDate(date);

  return formattedDate.getDate();
};

export default getDate;
